import { toast } from "react-toastify";
import { WarningToast } from "../components/toast/warning_toast";
import { ErrorToast } from "../components/toast/error_toast";
import { SuccessToast } from "../components/toast/success_toast";

export const showWarning = (message: string) => {
  toast(WarningToast, {
    data: {
      title: message,
    },
    type: "warning",
    icon: false,
  });
};

export const showError = (message: string) => {
  toast(ErrorToast, {
    data: {
      title: message,
    },
    type: "error",
    icon: false,
    autoClose: false,
  });
};

export const showSuccess = (message: string) => {
  toast(SuccessToast, {
    data: {
      title: message,
    },
    type: "success",
    icon: false,
  });
};
